/**
 * AI-generated code, moderated by lzygmanski
 */
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';
import type {PersonName} from '@/services/graphqlHooks';

export type AmbulancePrintContactInfoProps = {
  contactPersonPhoneNumber: string;
  careFacilityPhoneNumber?: string | null;
  contactPersonName: PersonName;
};

const AmbulancePrintContactInfo = ({
  contactPersonPhoneNumber,
  contactPersonName,
  careFacilityPhoneNumber,
}: AmbulancePrintContactInfoProps) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="h2" asChild className="text-lg font-semibold">
        <h2>{t('Contact information')}</h2>
      </Typography>
      <div className="grid grid-cols-2 gap-4">
        <div className="print:break-inside-avoid">
          <Typography className="text-sm font-medium">
            {t('Contact person phone')}:
          </Typography>
          {contactPersonPhoneNumber && (
            <Typography>{`${contactPersonName?.firstName || ''} ${
              contactPersonName?.lastName || ''
            }`}</Typography>
          )}
          <Typography>{contactPersonPhoneNumber || '-'}</Typography>
        </div>
        <div className="print:break-inside-avoid">
          <Typography className="text-sm font-medium">
            {t('Care facility phone')}:
          </Typography>
          <Typography>{careFacilityPhoneNumber || '-'}</Typography>
        </div>
      </div>
    </div>
  );
};

export default AmbulancePrintContactInfo;
